import { render, staticRenderFns } from "./NewAccountBtn.vue?vue&type=template&id=dcde7762&scoped=true&"
import script from "./NewAccountBtn.vue?vue&type=script&lang=js&"
export * from "./NewAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde7762",
  null
  
)

export default component.exports